import React from "react";
import { Link } from "react-router-dom";

/**
 * Pattern MalikaFit LoginBackToSite — retour site public depuis /connexion.
 */
export function LoginBackToSite({
  to = "/",
  label = "Retour au site",
  ariaLabel,
  testId = "login-back-to-site",
  className = "",
}) {
  return (
    <Link
      to={to}
      className={`karate-login-back ${className}`.trim()}
      data-testid={testId}
      aria-label={ariaLabel || label}
    >
      <span className="karate-login-back__arrow" aria-hidden="true">
        ←
      </span>
      <span className="karate-login-back__label">{label}</span>
    </Link>
  );
}
